import { type Schedule } from "@repo/api";

export const isScheduleWork = (schedule: Schedule) => {
  return (
    schedule.shiftType === "TRANSFER" ||
    schedule.shiftType === "REGULAR" ||
    schedule.shiftType === "PRESENCE" ||
    schedule.shiftType === "MEETING" ||
    schedule.shiftType === "WORK" ||
    schedule.activity?.toLowerCase() === "work"
  );
};
